export const tutorialVideos = [
  {
    id: 1,
    title: "Pengenalan Digital Storytelling",
    description: "Video pengantar tentang konsep dasar digital storytelling",
    youtubeId: "BlmBDrnhd2I",
    duration: "8:45",
    category: "Dasar",
  },
  {
    id: 2,
    title: "Cara Membuat Storyboard",
    description: "Tutorial membuat storyboard untuk konten pembelajaran",
    youtubeId: "zM9MYI6bVMk",
    duration: "12:30",
    category: "Desain",
  },
  {
    id: 3,
    title: "Teknik Recording Narasi",
    description: "Tips dan teknik recording narasi yang baik",
    youtubeId: "uv8mbL-MC58",
    duration: "10:15",
    category: "Produksi",
  },
  {
    id: 4,
    title: "Editing Video Dasar",
    description: "Tutorial editing video untuk pemula",
    youtubeId: "4v1CIKehF6E",
    duration: "15:20",
    category: "Editing",
  },
];